export function formatDashboardNumber(value: number): string {
  return value.toLocaleString('en-US', { maximumFractionDigits: 2 });
}
